module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_gaseosas_vidrio_350_ccsa.ea4f0b52.png";